export default {"src":"/_next/static/media/mail.f07a7c69.svg","height":16,"width":16};